import { Component, OnInit } from '@angular/core';
import { FormdashboardService } from '../../dashboard/formdashboard/formdashboard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveFile, saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { NgxSpinnerService } from "ngx-spinner";
import{cbadashboardService}from '../../dashboard/cbadashboard/cbadashboard.service';
import { ToastrService } from 'ngx-toastr';
import { TabHeadingDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-filedownload',
  templateUrl: './filedownload.component.html',
  styleUrls: ['./filedownload.component.css']
})
export class FiledownloadComponent implements OnInit {
  formconfigid: number = 0; mode: string = ''; formconfigname: string = '';
  userid: number = 0; advancedSearchId: number = 0;dbname:string='';link:string='';
  constructor(private _router: Router, private route: ActivatedRoute, 
    private formdashboardservice: FormdashboardService, private SpinnerService: NgxSpinnerService,
    private _cbadashboardService:cbadashboardService,private toastr: ToastrService) {
    this.route.queryParams.subscribe(params => {
      if (params['formconfigid'] != undefined)
        this.formconfigid = params['formconfigid'];
      if (params['mode'] != undefined)
        this.mode = params['mode'];
      if (params['formconfigname'] != undefined)
        this.formconfigname = params['formconfigname'];
      if (params['userid'] != undefined)
        this.userid = +params['userid'];
      if (params['advancedSearchId'] != undefined)
        this.advancedSearchId = +params['advancedSearchId'];
        if (params['dbname'] != undefined)
        this.dbname = params['dbname'];
        if (params['link'] != undefined)
        this.link = params['link'];
    });
  }


  ngOnInit() {
    console.log(this.formconfigid);
    if (this.mode == 'formdashbaord') {
      this.SpinnerService.show();
      this.formdashboardservice.getExportToExcel(this.formconfigid).subscribe(res => {
        if (res != undefined && res != null && res.length != 0) {
          var exportData = JSON.parse(res[0].j);
          exportData.map(function (obj) {
            delete obj.createdby; delete obj.createdon;
            delete obj.formconfigid; delete obj.documentid;
          });
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          var dateTime = date + ' ' + time;
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
          const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          this.saveAsExcelFile(excelBuffer, this.formconfigname + '-' + dateTime + '.xlsx');
          this.SpinnerService.hide();
        }
        else {
          this.SpinnerService.hide();
        }
      }
        , err => { this.SpinnerService.hide(); }
      );
    }
    if (this.mode == 'advancedsearch') {
      this.SpinnerService.show();
      let formdata: string = this.advancedSearchId + '*' + (+this.userid);
      this.formdashboardservice.getformadvancedsearchdetailsExportToExcel(formdata).subscribe(res => {
        if (res != undefined && res != null && res.length != 0) {
          var exportData = JSON.parse(res[0].formdetails);
          exportData.map(function (obj) {
            delete obj.createdby; delete obj.createdon;
            delete obj.formconfigid; delete obj.documentid;
          });
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          var dateTime = date + ' ' + time;
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
          const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          this.saveAsExcelFile(excelBuffer, this.formconfigname + '-' + dateTime + '.xlsx');
          this.SpinnerService.hide();
        }
        else {
          this.SpinnerService.hide();
        }

      }, err => { this.SpinnerService.hide(); }
      );
    }
    if(this.mode=='batchfile' || this.mode=='batchfileFinal'){
      debugger
      this.SpinnerService.show();
     
      var batchData = [];
    
      batchData.push(
        {
          'dbname':   this.dbname,
          'link':this.link,
          'formconfigid'  :this.formconfigid,
          'mode':this.mode  
        })
      this._cbadashboardService.downloadBatchFile(batchData[0]).subscribe(res=>
        {
          debugger
          var content = res.body.file;
          let objectURL = 'data:application/octet-stream;base64,' + res.body.file;   
         var link = document.createElement("a");       
         link.href = objectURL;
          document.body.appendChild(link);
        link.download = res.body.filename;
          link.click();
          document.body.removeChild(link);
          self.close()
          this.SpinnerService.hide();
         
        },err=>{
          this.toastr.error('File not found');

          this.SpinnerService.hide();
         self.close()
        })
    }

  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    var link = document.createElement("a");
    link.download = fileName;
    var url = window.URL.createObjectURL(data);
    link.href = url;
    document.body.appendChild(link);
    link.download = fileName;
    link.click();
    document.body.removeChild(link);
    self.close()
  }

}
